import { createContext, useContext } from 'react';
var DEFAULT_CONTEXT = {
    userData: {
        groupId: 0,
        role: 'teacher',
        teacherName: '',
        isTeacherPremium: false,
        schoolId: 0,
    },
    calendarData: {
        currentDate: new Date(),
        startDate: new Date(),
        weekRange: [new Date(), new Date()],
        days: [],
        isWeekInThePast: false,
        isCurrentWeek: false,
    },
    reportData: undefined,
    modals: {
        isInfoModalOpen: false,
        isAccuracyModalOpen: false,
        toggleInfoModal: function () { return undefined; },
        toggleAccuracyModal: function () { return undefined; },
    },
};
export var WeeklyDashboardContext = createContext(DEFAULT_CONTEXT);
export var useWeeklyDashboardContext = function () {
    var context = useContext(WeeklyDashboardContext);
    if (!context) {
        throw new Error('useWeeklyDashboardContext must be used within a WeeklyDashboardContextProvider');
    }
    return context;
};
